module.exports = function (app) {
    "use strict";
    app.controller('pages.architecture', ["$state", "$scope", "sessionData", "$filter", "employerUtility", "brand", "services", "$cookies", '$window', "modal", function ($state, $scope, sessionData, $filter, employerUtility, brand, services, $cookies, $window, modal) {

    }]);

    return [
        {
            state: "architecture",
            url: "/architecture",
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page.html'],
                    controller: "pages.architecture"
                },
                "content@architecture": {
                    templateUrl: 'architecture.employerTemplate.html/pages/architecture'
                }
            }
        }
    ];
};
